module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/131-chile-6d73c081cf8920ca7bd5d000d7dd5b95.svg";